// HomePage.jsx
import React from 'react';
import { Link } from 'react-router-dom';
import logo from './assets/logo.png';
import './HomePage.css';

export default function HomePage() {
  return (
    <div className="home-container">
      <img src={logo} alt="Formal Invites Logo" className="home-logo" />
      <h1 className="home-title">Welcome to Formal Invites</h1>
      <p className="home-tagline">Scan your event's QR code to view or upload photos.</p>

      <Link to="/admin" className="admin-link">Admin Login</Link>
    </div>
  );
}
